/**
 * Type guard to check if a value is not null or undefined
 * @param value - The value to check
 * @returns true if the value is neither null nor undefined
 */
export function isNotNullish<T>(
  value: T | null | undefined,
): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

/**
 * Type guard to check if a value is null or undefined
 * @param value - The value to check
 * @returns true if the value is null or undefined
 */
export function isNullish(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}
